<template>
  <v-dialog v-model="dialog" scrollable width="750">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo phiếu Báo hỏng & Yêu cầu sửa chữa</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <RepairForm ref="repairForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">GỬI YÊU CẦU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RepairForm from '@/modules/facility/maintenance/RepairForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'RepairNewDialog',
  components: { RepairForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityMaintenance', ['createRepair']),
    cancel() {
      this.dialog = false
      if (this.$refs.repairForm) {
        this.$refs.repairForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.repairForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.repairForm.getData()
        await this.createRepair(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
